<template>
  <v-select
    class="extent-mode-dropdown pt-0"
    style="width: 240px;"
    :menu-props="{ offsetY: true }"
    solo
    single-line
    :value="activeGeographicFilterMode"
    aria-label="Velg avgrensningsmodus"
    v-model="activeGeographicFilterMode"
    :items="geographicFilterOptions"
    hide-details
    placeholder="Velg avgrensningsmodus"
    @change="onConstraintModeChanged"
  ></v-select>
</template>

<script>
import { mapActions, mapState } from "vuex";

export default {
  name: "MapGeographicFilter",
  computed: {
    ...mapState(["geographicFilterOptions"]),
    activeGeographicFilterMode: {
      get() {
        return this.$store.state.activeGeographicFilterMode;
      },
      set(activeGeographicFilterMode) {
        this.setActiveGeographicFilterMode(activeGeographicFilterMode);
      },
    },
  },
  data() {
    return {
      mapViewObject: Object,
      tegnelag: Object,
      bufferlayer: Object,
      selectionlayer: Object,
      hovedlag: Object,
      operationalLayers: [],
      kartlastet: false,
      tidsrom: Array,
      ekskluderteTidsserier: [],
      loadedBasemaps: [],
      menuOpen: false,
    };
  },
  methods: {
    ...mapActions(["setActiveGeographicFilterMode", "setUseMapExtent"]),
    onConstraintModeChanged: function(value) {
      this.menuOpen = !this.menuOpen;
      if (value === this.geographicFilterOptions[1]) {
        this.setUseMapExtent(true);
      } else {
        this.setUseMapExtent(false);
      }
    },
  },
};
</script>

<style>
.extent-mode-dropdown {
  position: absolute;
  top: 10px;
  left: 10px;
  padding-top: 0px;
}
</style>
